import { toast } from 'react-toastify';
import { Api } from '../lib/api/api';

export const setActiveCallsTab = tab => dispatch => {
  dispatch({
    type: 'SET_ACTIVE_CALLS_TAB',
    tab,
  });
};

export const outgoingCallsByCompany = (
  token,
  filter = null,
  paginateOptions,
  date,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_CALLS',
  });
  try {
    const outgoingCallsFilterCompany = await api.calls.getOutgoingCallsByCompany(
      filter,
      paginateOptions,
      date,
    );
    dispatch({
      type: 'OUTGOING_CALLS_FILTER_COMPANY_SUCCESS',
      outgoingCallsFilterCompany,
    });
  } catch (error) {
    dispatch({
      type: 'OUTGOING_CALLS_FILTER_COMPANY_ERROR',
    });
  }
};

export const onRecoverIncomingCall = (token, callId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_INCOMING_CALL',
  });
  try {
    await api.calls.onRecoverIncomingCall(callId);
    dispatch({
      type: 'RECOVER_INCOMING_CALL_SUCCESS',
    });
    toast.success('Call Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_INCOMING_CALL_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Call`);
  }
};

export const onRecoverOutgoingCall = (token, callId) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'RECOVER_OUTGOING_CALL',
  });
  try {
    await api.calls.onRecoverOutgoingCall(callId);
    dispatch({
      type: 'RECOVER_OUTGOING_CALL_SUCCESS',
    });
    toast.success('Call Recovered Successfully!');
    return true;
  } catch (error) {
    dispatch({
      type: 'RECOVER_OUTGOING_CALL_FAILURE',
      error,
    });
    toast.error(error.response.data || `Error in recovering Call`);
  }
};

export const deleteOutgoingCall = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_CALL',
    id,
  });
  try {
    const deletedCall = await api.calls.deleteOutgoingCall(id);
    dispatch({
      type: 'DELETE_CALL_SUCCESS',
      deletedCall,
    });
    dispatch({
      type: 'DELETE_USER_CANCEL',
    });
    toast.success('Call deleted!');
    return deletedCall;
  } catch (error) {
    dispatch({
      type: 'DELETE_CALL_FAILURE',
      error,
    });
    dispatch({
      type: 'DELETE_USER_CANCEL',
    });
    toast.error(`Error in deleting Call`);
  }
};

export const deleteIncomingCall = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'DELETE_CALL',
    id,
  });
  try {
    const deletedCall = await api.calls.deleteIncomingCall(id);
    dispatch({
      type: 'DELETE_CALL_SUCCESS',
      deletedCall,
    });
    dispatch({
      type: 'DELETE_USER_CANCEL',
    });
    toast.success('Call deleted!');
    return deletedCall;
  } catch (error) {
    dispatch({
      type: 'DELETE_CALL_FAILURE',
      error,
    });
    dispatch({
      type: 'DELETE_USER_CANCEL',
    });
    toast.error(`Error in deleting Call`);
  }
};

export const incomingCallsFilter = filter => dispatch => {
  dispatch({
    type: 'INCOMING_CALLS_FILTER_COMPANY',
    filter,
  });
};

export const outgoingCallsFilter = filter => dispatch => {
  dispatch({
    type: 'OUTGOING_CALLS_FILTER_COMPANY',
    filter,
  });
};

export const getOutgoingCallsByDate = (token, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_CALLS',
  });
  try {
    const outgoingCallsFilterCompany = await api.calls.getOutgoingCallsByDate(dateFilter);
    dispatch({
      type: 'OUTGOING_CALLS_FILTER_COMPANY_SUCCESS',
      outgoingCallsFilterCompany,
    });
  } catch (error) {
    dispatch({
      type: 'OUTGOING_CALLS_FILTER_COMPANY_ERROR',
    });
  }
};

export const outgoingCallsByFilter = (
  token,
  filter = null,
  paginateOptions,
  date,
  cid,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_CALLS_BY_FILTER',
  });
  try {
    const outgoingCallsByFilter = await api.calls.outgoingCallsByFilter(
      filter,
      paginateOptions,
      date,
      cid,
    );
    dispatch({
      type: 'OUTGOING_CALLS_BY_FILTER_SUCCESS',
      outgoingCallsByFilter,
    });
  } catch (error) {
    dispatch({
      type: 'OUTGOING_CALLS_BY_FILTER_ERROR',
    });
  }
};

export const getIncomingCallsByDate = (token, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_CALLS',
  });
  try {
    const incomingCallsFilterCompany = await api.calls.getIncomingCallsByDate(dateFilter);
    dispatch({
      type: 'INCOMING_CALLS_FILTER_COMPANY_SUCCESS',
      incomingCallsFilterCompany,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_CALLS_FILTER_COMPANY_ERROR',
    });
  }
};

export const incomingCallsByFilter = (
  token,
  filter = null,
  paginateOptions,
  date,
  cid,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_CALLS_BY_FILTER',
  });
  try {
    const incomingCallsByFilter = await api.calls.incomingCallsByFilter(
      filter,
      paginateOptions,
      date,
      cid,
    );
    dispatch({
      type: 'INCOMING_CALLS_BY_FILTER_SUCCESS',
      incomingCallsByFilter,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_CALLS_BY_FILTER_ERROR',
    });
  }
};

export const incomingCallRecords = (token, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_CALLS',
  });
  try {
    await api.calls.incomingCallRecords(dateFilter);
  } catch (error) {
    console.log('error :: ', error);
  }
};

export const outgoingCallRecords = (token, dateFilter) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'OUTGOING_CALLS',
  });
  try {
    await api.calls.outgoingCallRecords(dateFilter);
  } catch (error) {
    console.log('error :: ', error);
  }
};

export const incomingCallsByCompany = (
  token,
  filter = null,
  paginateOptions,
  date,
) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'INCOMING_CALLS',
  });
  try {
    const incomingCallsFilterCompany = await api.calls.getIncomingCallsByCompany(
      filter,
      paginateOptions,
      date,
    );
    dispatch({
      type: 'INCOMING_CALLS_FILTER_COMPANY_SUCCESS',
      incomingCallsFilterCompany,
    });
  } catch (error) {
    dispatch({
      type: 'INCOMING_CALLS_FILTER_COMPANY_ERROR',
    });
  }
};

export const getOutgoingCalls = (token, paginateOptions) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_OUTGOING_CALLS',
  });

  try {
    const outgoingCalls = await api.calls.getOutgoingCalls(paginateOptions);
    dispatch({
      type: 'GET_OUTGOING_CALLS_SUCCESS',
      outgoingCalls,
    });
  } catch (error) {
    dispatch({
      type: 'GET_OUTGOING_CALLS_ERROR',
    });
  }
};

// TEMP CODES

export const getOutgoingCallsList = (token, ...name) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_OUTGOING_CALLS_LIST',
  });

  try {
    const outgoingCallsList = await api.calls.getOutgoingCallsList();
    dispatch({
      type: 'GET_OUTGOING_CALLS_LIST_SUCCESS',
      outgoingCallsList,
      name,
    });
  } catch (error) {
    dispatch({
      type: 'GET_OUTGOING_CALLS_LIST_ERROR',
    });
  }
};

export const getIncomingCallsList = (token, ...name) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_INCOMING_CALLS_LIST',
  });

  try {
    const incomingCallsList = await api.calls.getIncomingCallsList();
    dispatch({
      type: 'GET_INCOMING_CALLS_LIST_SUCCESS',
      incomingCallsList,
      name,
    });
  } catch (error) {
    dispatch({
      type: 'GET_INCOMING_CALLS_LIST_ERROR',
    });
  }
};

export const getOutgoingCallsByCompany = (token, company, paginateOptions) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_OUTGOING_CALLS_BY_COMPANY',
  });

  try {
    const outgoingCallsByCompany = await api.calls.getOutgoingCallsByCompany(
      company,
      paginateOptions,
    );
    dispatch({
      type: 'GET_OUTGOING_CALLS_BY_COMPANY_SUCCESS',
      outgoingCallsByCompany,
    });
  } catch (error) {
    dispatch({
      type: 'GET_OUTGOING_CALLS_BY_COMPANY_ERROR',
    });
  }
};

export const getIncomingCalls = (token, paginateOptions) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_INCOMING_CALLS',
  });

  try {
    const incomingCalls = await api.calls.getIncomingCalls(paginateOptions);
    dispatch({
      type: 'GET_INCOMING_CALLS_SUCCESS',
      incomingCalls,
    });
  } catch (error) {
    dispatch({
      type: 'GET_INCOMING_CALLS_ERROR',
    });
  }
};

export const downloadOutgoingCalls = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_OUTGOING_CALLS_SAVE',
  });

  try {
    await api.calls.downloadOutgoingCalls(id);
    // dispatch({
    //   type: 'GET_OUTGOING_CALLS_SAVE_SUCCESS',
    //   // id,
    //   // userID
    // });
  } catch (error) {
    dispatch({
      type: 'GET_OUTGOING_CALLS_SAVE_ERROR',
    });
  }
};

export const downloadIncomingCalls = (token, id) => async dispatch => {
  const api = new Api(token);
  dispatch({
    type: 'GET_INCOMING_CALLS_SAVE',
  });

  try {
    await api.calls.downloadIncomingCalls(id);
    // dispatch({
    //   type: 'GET_INCOMING_CALLS_SAVE_SUCCESS',
    //   // id,
    //   // userID
    // });
  } catch (error) {
    dispatch({
      type: 'GET_INCOMING_CALLS_SAVE_ERROR',
    });
  }
};

export const callsPlayer = (token, id, type) => () => {
  const api = new Api();
  const res = api.calls.callsPlayer(token, id, type);
  return res;
};
